<template>
    <div class="h-1/1 w-full bg-login">
        <LeaveReviewComponent :p_aid="$page.props.property_id" class="p-4" />
    </div>
</template>

<script>
import LeaveReviewComponent from "../../components/holidaymaker/LeaveReviewComponent.vue";

export default {
    name: "LeaveReview",
    components: { LeaveReviewComponent }
};
</script>
